export default {
    apiKey: "AIzaSyBTe9EaeM4XMRcOihyYGNandIyV5YH17qE",
    authDomain: "vue-task-list-4fb54.firebaseapp.com",
    databaseURL: "https://vue-task-list-4fb54-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "vue-task-list-4fb54",
    storageBucket: "vue-task-list-4fb54.firebasestorage.app",
    messagingSenderId: "656330878517",
    appId: "1:656330878517:web:2d842b9e15596b0b898b7c"  
}